import { object, string, date, array, number, boolean } from 'yup';

export const unserializedReceivingValidation = () =>
  object().shape({
    orderItems: array().of(
      object().shape({
        productId: string().required('Product ID required'),
        quantity: number().required('Quantity required'),
        missing: boolean().required('Missing required')
      })
    )
  });
